import { PerfilComponent } from './../perfil/perfil.component';
import { Form } from './../../models/form.model';
import { UserService } from 'src/app/services/user.service';
import { MatDialog, MatSnackBar } from 'node_modules/@angular/material';
import { Component } from '@angular/core';
import { trigger, transition, style, animate, query, stagger, animateChild } from "@angular/animations";
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { OptionService } from 'src/app/services/options.service';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import { AuxUrlComponent } from '../auxUrl/auxUrl.component';
import { AuxUrlcertComponent } from '../auxUrlcert/auxUrlcert.component';
import { GLOBAL } from 'src/app/services/global';
interface AppState {
  form: Form;
}
@Component({
  selector: 'page-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
  providers: [FormService, OptionService, UserService],
  animations: [
    trigger('items', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),  // initial
        animate('1.2s cubic-bezier(.8, -0.6, 0.26, 1.6)',
          style({ transform: 'scale(1)', opacity: 1 }))  // final
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1, height: '*' }),
        animate('0.6s cubic-bezier(.8, -0.6, 0.2, 1.5)',
          style({
            transform: 'scale(0.5)', opacity: 0,
            height: '0px', margin: '0px'
          }))
      ])
    ]),
    trigger('list', [
      transition(':enter', [
        query('@items', stagger(150, animateChild()))
      ]),
    ])
  ]
})


export class InicioComponent {

  public form;
  matcher = new FormService();
  servicios = [];
  inputBuscar;
  identity;
  token;
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;


  constructor(private _optionService: OptionService, private dialog: MatDialog,
    private _userService: UserService, private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService, private store: Store<AppState>, private route: ActivatedRoute) {


    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    localStorage.clear();
    sessionStorage.removeItem('borrador');
    this.form = new FormGroup({
      buscar: new FormControl('', Validators.required)
    })
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    if (this.route.snapshot.paramMap.get("token")) {
      this._userService.activeUser(this.route.snapshot.paramMap.get("token")).subscribe(
        response => {
          console.log('cuenta activada, response', response)
          if (response.active) {
            alert("Cuenta activada");
          }
        },
        error => {
          let e = JSON.parse(error._body);
          alert(e.message);
        }
      )
    }


    this.spinner.show();
    this._optionService.getServices().subscribe(
      response => {
        this.servicios = response;
        console.log(this.servicios)
        this.spinner.hide();
      },
      error => {
        console.log(error);
        this.spinner.hide();

        console.log("Verifique la conexión a internet.")
      }
    )


  }

  sign(active?, url?) {
    console.log(active, url)
    if (active == true && url == 'expedientes') {
      this.dialog.open(AuxUrlComponent, {
        width: '80%',
        maxWidth: '550px',
        data: {
          url: url
        }
      })

    } else if (active) {
      switch (url) {
        case 'certificados':
          this.dialog.open(AuxUrlcertComponent, {
            width: '80%',
            maxWidth: '550px',
            data: {
              url: url
            }
          })
          break;
        case 'arquitectos':
          // console.log("holaaa")
          window.location.href = "https://reservadehoras.lascondes.cl/#/servicios/unit-34";
          break;
        case 'inspeccion':
          this.snackBar.open("Opción deshabilitada", "Cerrar", {
            duration: 3000,
          });
          break;

        //case 'totem':
        //window.open(´${GLOBAL.totemUrl}´, "_blank")
        //break;
      }
    }
  }

  ngOnInit() {

  }

  ngDoCheck() {

    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }




}